function setCollection(collectionName) {
  // Get all elements with class 'product-display-area'
  console.log("collectionName", collectionName);

  const productAreas = document.querySelectorAll(".product-display-area");

  // Hide all product areas
  productAreas.forEach((productArea) => (productArea.style.display = "none"));

  // Show the requested product area
  const requestedProductArea = document.querySelector(
    `.product-display-area.${collectionName}`
  );

  if (requestedProductArea) {
    requestedProductArea.style.display = "flex";
  }
}

function showGrandchildren() {
  console.log("showGrandchildren");

  const grandchildren = document.getElementById("grandchildren");

  if (grandchildren) {
    grandchildren.style.display = "grid";
  }
}

// show first collection
let firstCollection = document.querySelector(".product-display-area");
console.log("firstCollection to display: ", firstCollection);

// change style
firstCollection.style.display = "flex";
